import { type SelectionFeature, type SelectionPermissions } from '../types';

/**
 * Filters features by calling each one's isEnabled() gate.
 * Features without isEnabled are always included.
 *
 *   features ──► [ f.isEnabled?.(perms) !== false ] ──► surviving
 */
export function filterByPermissions(
  features: readonly SelectionFeature[],
  permissions: SelectionPermissions
): SelectionFeature[] {
  return features.filter((f) => f.isEnabled?.(permissions) !== false);
}
